<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
               <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                     <b class="white--text">{{cutOffPeriod}}</b>
                     <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1" style="margin-top:5px;">
                <v-toolbar flat height="35px">
                    <v-text-field v-model="search" append-icon="search" label="Search name" single-line hide-details style="margin-bottom:15px;"></v-text-field>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="black"></help-link>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="overtime_details_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" style="cursor:pointer;" title="Click to view timesheet for this period">
                            <td>{{ props.item.teamName }}</td>
                            <td>
                                <v-chip>
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>{{ props.item.transDate | moment("YYYY-MM-DD") }}</td>
                            <td>{{props.item.startTime|moment('hh:mm a')}}-{{props.item.endTime|moment('hh:mm a')}}</td>
                            <td>{{ props.item.projectTaskKey }} : {{ props.item.taskName }}</td>
                            <td>
                                <span v-if="props.item.offsetOrPay==1">Offset</span>
                                <span v-else>Payroll</span>
                            </td>
                            <td>{{ props.item.hours }}</td>
                            <td>{{ props.item.chargeableHours }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

    </v-layout>  
</template>

<script>

import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'Overtime',
    metaInfo: {
        title: 'Overtime',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Overtime' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            rowsPerPageItems,
            commonfn,
            awsS3Helper,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            headers: [
                {text: 'Team',align: 'left',value: 'teamName', width:'10%', sortable:true},
                {text: 'Employee',align: 'left',value: 'lastName', width:'15%', sortable:true},
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Start/End',align: 'left',value: 'startTime', width:'10%',sortable:true}, 
                {text: 'Project Task',align: 'left',value: 'taskName', width:'15%',sortable:true},
                {text: 'Purpose',align: 'left',value: 'offsetOrPay', width:'5%',sortable:true},
                {text: 'Total Hours',align: 'left',value: 'hours', width:'5%',sortable:true},
                {text: 'Chargeable Hours',align: 'left',value: 'chargeableHours', width:'5%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'5%',sortable:true},
            ],
            cutoff_details: null,
            overtime_details: [],
            search: null
        }
    },
    methods: {  
        viewDetails(data) {
            this.$router.push(`/company/overtime/details/${data.overtimeId}`)
        }, 
        async getOvertime() {
            try {
                this.loading = true
                const response = await overtimeApi.getByCutoffByCompany(this.selectedCutOffId)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.overtime_details = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Company Overtime'
        })

        this.getOvertime()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details)
                return `${this.$moment(this.cutoff_details.cutoffStart).format('MMM DD, YYYY')} to ${this.$moment(this.cutoff_details.cutoffEnd).format('MMM DD, YYYY')}`
        },
        overtime_details_filtered() {
            var temp = this.overtime_details

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.firstName.toLowerCase().includes(this.search.toLowerCase()) || item.lastName.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
            return temp
        },
        helpPageId() {
            return 'overtime-review-company'
        },
        frozenPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        }
    }
}
</script>